import { delay, takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import {
  EXAMPLES_TESTE_SAGA_BEGIN,
  EXAMPLES_TESTE_SAGA_SUCCESS,
  EXAMPLES_TESTE_SAGA_FAILURE,
  EXAMPLES_TESTE_SAGA_DISMISS_ERROR,
} from './constants';

export function testeSaga() {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: EXAMPLES_TESTE_SAGA_BEGIN,
  };
}

export function dismissTesteSagaError() {
  return {
    type: EXAMPLES_TESTE_SAGA_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on EXAMPLES_TESTE_SAGA_BEGIN actions
export function* doTesteSaga() {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield call(delay, 20);
  } catch (err) {
    yield put({
      type: EXAMPLES_TESTE_SAGA_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: EXAMPLES_TESTE_SAGA_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchTesteSaga() {
  yield takeLatest(EXAMPLES_TESTE_SAGA_BEGIN, doTesteSaga);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case EXAMPLES_TESTE_SAGA_BEGIN:
      return {
        ...state,
        testeSagaPending: true,
        testeSagaError: null,
      };

    case EXAMPLES_TESTE_SAGA_SUCCESS:
      return {
        ...state,
        testeSagaPending: false,
        testeSagaError: null,
      };

    case EXAMPLES_TESTE_SAGA_FAILURE:
      return {
        ...state,
        testeSagaPending: false,
        testeSagaError: action.data.error,
      };

    case EXAMPLES_TESTE_SAGA_DISMISS_ERROR:
      return {
        ...state,
        testeSagaError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/examples/redux/testeSaga.js